import Fab from '@mui/material/Fab'
import MenuIcon from '@mui/icons-material/Menu'
import { Drawer, List, ListItem, ListItemIcon, ListItemText } from '@mui/material'
import { useState } from 'react'
import {Link} from 'react-router-dom';
import Box from '@mui/material/Box'

import StorefrontIcon from '@mui/icons-material/Storefront';
import OtherHousesIcon from '@mui/icons-material/OtherHouses';
import PeopleIcon from '@mui/icons-material/People';
const SideMenu = (props) =>{

  const close = () => {
    props.controlfunc(false);
    props.setMainPosition(0);
  };

  return (
    <>
      <Drawer
        open={props.open}
        onClose={() => {close()}}
        anchor="left"
      >
        <Box sx={{width:230,top: 100,paddingBlock:0,m:0}} >
          <List>
            <ListItem >
              <ListItemIcon>
                <OtherHousesIcon />
              </ListItemIcon>
              <Link to="/" >
                <ListItemText onClick={()=>{close()}} primary="トップ" />
              </Link>
            </ListItem>
            <ListItem >
              <ListItemIcon>
                <StorefrontIcon />
              </ListItemIcon>
              <Link to="/tenant" >
                <ListItemText onClick={()=>{close()}} primary="テナント管理" />
              </Link>
            </ListItem>
            <ListItem >
              <ListItemIcon>
                <PeopleIcon />
              </ListItemIcon>
              <Link to="/adminuser" >
                <ListItemText onClick={()=>{close()}} primary="システム管理者" />
              </Link>
            </ListItem>
            <ListItem >
              <ListItemIcon>
                <PeopleIcon />
              </ListItemIcon>
              <Link to="/user" >
                <ListItemText onClick={()=>{close()}} primary="一般ユーザ" />
              </Link>
            </ListItem>
            <ListItem >
              <ListItemIcon>
                <PeopleIcon />
              </ListItemIcon>
              <Link to="/sysadmin" >
                <ListItemText onClick={()=>{close()}} primary="プロダクト管理者" />
              </Link>
            </ListItem>
          </List>
        </Box>
      </Drawer>


    </>
  );
}

export default SideMenu